import React, { useEffect, useState } from "react";
import {
  add_circle,
  card_gray,
  download,
  edit,
  copy,
  trash_can,
} from "../assets";
import ModalDelete from "./modals/ModalDelete";
import { deleteSignature } from "../constants";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { email_signature } from "../assets";
import Signature from "./Signature.jsx";
import ModalCopySignature from "./modals/ModalCopySignature";

const EmailSignatures = ({ signatures }) => {
  const cards = [];
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [data, setData] = useState(null);

  const handleDownload = () => {
    let canvas = document.getElementById("qr_id");
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `QR-` + cards[index].card_name + `.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      toast.success("QR code downloaded", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const handleCopyEmailSignature = (e) => {
    e.preventDefault();
    const linkElement = document.getElementById("EmailSignature");
    const tagContent = linkElement.outerHTML;
    const htmlBlob = new Blob([tagContent], { type: "text/html" });
    const item = new ClipboardItem({
      "text/html": htmlBlob,
    });
    navigator.clipboard
      .write([item])
      .then(() => {
        toast.success("Email signature copied!", {
          position: "top-center",
          autoClose: 3000,
        });
      })
      .catch((err) => {
        toast.error("Failed to copy email signature", {
          position: "top-center",
          autoClose: 3000,
        });
      });
  };

  useEffect(() => {
    const msg = localStorage.getItem("toastMsg", "");
    if (Boolean(msg)) {
      // localStorage.removeItem("toastMsg");
      toast.success(msg, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          localStorage.removeItem("toastMsg");
        },
      });
    }
  }, []);

  useEffect(() => {
    if (signatures.length > 0) {
      setData({ ...signatures[index] });
    }
  }, [index, signatures]);

  return (
    <div className="flex flex-col md:flex-row w-full h-full bg-white overflow-y-auto pb-32 md:pb-0">
      <ToastContainer />
      <div className="hidden md:flex flex-col border-0 border-r-2 border-r-gray-200 w-1/5 px-5 py-5 gap-3 text-black">
        <div
          className="flex flex-row items-center gap-2 pb-3 cursor-pointer hover:font-bold active:font-semibold"
          onClick={() => {
            navigate("/signatures/create");
          }}
        >
          <img src={add_circle} className="w-[20px] h-[20px]" />{" "}
          <div>Add Signature</div>
        </div>
        {signatures.map((val, ind) => (
          <div
            className={`cursor-pointer hover:font-bold ${
              ind == index ? "font-bold" : ""
            }`}
            onClick={() => setIndex(ind)}
            key={ind}
          >
            {val.name}
          </div>
        ))}
      </div>

      <form className="flex flex-row w-full md:hidden p-5 gap-3 border-b">
        <select
          id="cards"
          className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-5 py-3"
          value={index}
          onChange={(e) => setIndex(e.target.value)}
        >
          {signatures.length > 0 ? (
            signatures.map((val, ind) => (
              <option key={ind} value={ind}>
                {val.name}
              </option>
            ))
          ) : (
            <option>Email Signature</option>
          )}
        </select>
        <div
          className="flex flex-row items-center cursor-pointer hover:font-bold active:font-semibold justify-center w-1/6"
          onClick={() => {
            navigate("/signatures/create");
          }}
        >
          <img src={add_circle} className="w-[30px] h-[30px]" />{" "}
        </div>
      </form>

      <div className="flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-4/5 px-10 py-5 gap-3 items-center">
        <div className="flex flex-row justify-between w-full">
          <div>Email Signatures</div>
          <div className="flex flex-row gap-1">
            <div
              className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
              onClick={
                signatures.length > 0
                  ? () => {
                      navigate(
                        "/signatures/update/" + signatures[index].email_sg_id,
                      );
                      // setCardData(cards[index]);
                      // setBreads([...breads, cards[index].card_name]);
                    }
                  : null
              }
            >
              <img src={edit} alt="edit" className="w-[20px]" />
            </div>

            <div
              className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
              onClick={
                signatures.length > 0
                  ? () => document.getElementById("delete_modal").showModal()
                  : null
              }
            >
              <img src={trash_can} alt="trash_can" className="w-[20px]" />
            </div>
          </div>
        </div>
        <div className="flex flex-col h-full w-full px-0 md:px-10 py-5 justify-center items-center">
          {signatures.length > 0 && data != null ? (
            <div className="flex flex-col gap-5 items-center justify-center w-full">
              <a
                href={"https://app.nitomeyocard.com/me/" + data.card.slug}
                id="EmailSignature"
                target="_blank"
              >
                <img
                  src={data.image.url}
                  alt=""
                  className="shadow-lg !w-[600px]"
                />
              </a>
              <div
                className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-tertiary cursor-pointer w-fit"
                onClick={
                  signatures.length > 0
                    ? () =>
                        document
                          .getElementById("copy_signature_modal")
                          .showModal()
                    : null
                }
              >
                Copy Email Signature
              </div>
            </div>
          ) : (
            <div
              className="flex flex-col gap-10 w-full justify-center items-center relative rounded-lg z-0"
              id="CardTemplate"
            >
              <img src={email_signature} alt="" className="h-full" />
              <div
                className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-tertiary cursor-pointer"
                onClick={() => {
                  navigate("/signatures/create");
                }}
              >
                Create Email Signature
              </div>
            </div>
          )}
        </div>
      </div>
      <ModalDelete type={"signature"} data={data} setFunc={deleteSignature} />
      <ModalCopySignature copyFunc={handleCopyEmailSignature} />
    </div>
  );
};

export default EmailSignatures;
